module.exports = __webpack_public_path__ + "img/tictactoe-gaoubouzi-bouzi-project.3fa11072.png";